import { chartTypes } from '@/components/charts/common/chartTypes';
import { LinearBubbleRenderer } from '@/components/charts/LinearBubble/LinearBubbleRenderer';
import { LinearBubbleScaler } from '@/components/charts/LinearBubble/LinearBubbleScaler';
import { LinearBubbleTooltip } from '@/components/charts/LinearBubble/LinearBubbleTooltip';

export class LinearBubbleModule {
    static get type () {
        return chartTypes.LINEARBUBBLE;
    }

    constructor ({ canvas, chartRenderer, chartDataHelper, chartInteractions }) {
        this.scaler = new LinearBubbleScaler({
            canvas, chartDataHelper
        });

        this.tooltip = new LinearBubbleTooltip({
            type: LinearBubbleModule.type, chartInteractions, chartDataHelper
        });

        this.renderer = new LinearBubbleRenderer({
            chartRenderer,
            chartDataHelper,
            chartInteractions,
            scaler: this.scaler
        });
    }

    render (mode) {
        this.scaler.buildScales(this.renderer.context);
        this.renderer.render(mode);
    }
}
